import React from "react";
import Fit from "./Fit";
import "./HeldUp.scss";

const PrintHeldUpCertificate = () => {
  return <Fit noHeader />;
};
export default PrintHeldUpCertificate;
